<template>
  <v-dialog v-model="packageList" persistent max-width="1000">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="selectedPackage ? returnPackageName : ''"
        label="Firmware Package"
        prepend-inner-icon="mdi-folder"
        :error-messages="errorMessages"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-card :loading="loading">
      <v-card-text>
        <br />
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <br />
        <v-data-table
          :headers="headers"
          :items="firmwarePackages"
          :search="search"
          item-key="firmware_id"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, key) in items" :key="item.firmware_id" :class="key === selectedRow ? 'custom-highlight-row' : ''"   @click="rowSelect(key, item)">
                <td>{{ item.created_on }}</td>
                <td class="text-xs-right">{{ item.created_by_user_email }}</td>
                <td class="text-xs-right">{{ item.model }}</td>
                <td class="text-xs-right">{{ item.rev }}</td>
                <td class="text-xs-right">{{ item.description }}</td>
                <td class="text-xs-right">{{ item.version }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="packageList = false">Cancel</v-btn>
        <v-btn color="green darken-1" text :disabled="!Boolean(selectedPackage)" @click="packageList = false">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { GetFirmwarePackage } from "@/services/API.js"
import { mapGetters } from "vuex"

import { Logger } from "aws-amplify"
const logger = new Logger("Package Selector")

export default {
  props: {
    value: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
    errorMessages: {
      type: Array,
      required: false,
      default() {
        return []
      },
    }
  },
  data() {
    return {
      packageList: false,
      selectedPackage: null,
      selectedRow: null,
      selectedId: -1,
      firmwarePackages: [],
      loading: true,
      headers: [
        { 
          text: "Created On", 
          value: "created_on" 
        },
        { 
          text: "Created By", 
          value: "created_by_user_email" 
        },
        { 
          text: "Model", 
          value: "model" 
        },
        { 
          text: "Revision", 
          value: "rev" 
        },
        {
          text: 'Description',
          value: 'description'
        },
        { 
          text: "Version", 
          value: "version" 
        }
      ],
      search: ''
    }
  },
  computed: {
    ...mapGetters(["orgId"]),
    returnPackageName() {
      return this.selectedPackage.model + ', ' + this.selectedPackage.version;
    }
  },
  watch: {
    selectedPackage(val) {
      if (val) {
        this.$emit("input", val)
      }
    },
  },
  async created() {
    const res = await GetFirmwarePackage(this.orgId)
    if (res.Firmware) {
      this.firmwarePackages = res.Firmware
    }
    this.loading = false
  },
  methods: {
    rowSelect(idx, item) {
      logger.info(idx)
      this.selectedRow = idx;
      this.selectedPackage = item;
    }
  },
}
</script>

<style lang="scss">
.firmware-item {
  cursor: pointer;
  &.selected {
    background: #eee;
  }
}

.custom-highlight-row{
  background-color: #8abfff5e
}
</style>
